import { render, staticRenderFns } from "./lighting.vue?vue&type=template&id=27518e29&scoped=true"
import script from "./lighting.vue?vue&type=script&lang=js"
export * from "./lighting.vue?vue&type=script&lang=js"
import style0 from "./lighting.vue?vue&type=style&index=0&id=27518e29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27518e29",
  null
  
)

export default component.exports